// app/frontend/controllers/color_picker_controller.ts
import { Controller } from "@hotwired/stimulus"

// 色選択用Stimulusコントローラー
// ラジオボタンで選択された色に応じてテンプレート画像を差し替える
export default class extends Controller {
  // markup/* は廃止予定のため preview ターゲットは使用しない
  private templateChangeHandler = () => this.applySelectedColor()

  connect() {
    document.addEventListener("template:active-changed", this.templateChangeHandler)
    this.applySelectedColor()
  }

  disconnect() {
    document.removeEventListener("template:active-changed", this.templateChangeHandler)
  }

  // ラジオボタン変更時のイベントハンドラ
  change(event: Event) {
    const input = event.target as HTMLInputElement
    const colorName = input.dataset.colorName
    if (colorName) {
      this.updateActiveSlideImage(colorName)
    }
  }

  // 初期選択色の適用
  applySelectedColor() {
    const colorName = this.getSelectedColorName()
    if (colorName) {
      this.updateActiveSlideImage(colorName)
    }
  }

  private getSelectedColorName(): string | null {
    const selected = this.element.querySelector<HTMLInputElement>('input[name="color"]:checked')
    return selected?.dataset.colorName || null
  }

  // 選択されたカラー名に基づいてアクティブなテンプレート画像のみを更新
  private updateActiveSlideImage(colorName: string) {
    const activeSlide = document.querySelector<HTMLElement>('.p-template__swiper__slide.swiper-slide-active')
    if (!activeSlide) return

    const img = activeSlide.querySelector<HTMLImageElement>('.p-template__swiper__slide__image')
    const imagePathsJson = activeSlide.dataset.imagePaths
    if (img && imagePathsJson) {
      try {
        const imagePaths = JSON.parse(imagePathsJson) as Record<string, string>
        const newImagePath = imagePaths[colorName]
        if (newImagePath) {
          img.src = newImagePath
        }
      } catch (e) {
        console.error('Failed to parse image paths:', e)
      }
    }
  }
}
